import React, { useEffect, useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import UploadDoc from "../../../assests/upload.png";
import Document_show from "../../../assests/Document_show.png";
import { Api, fetchFileWithId } from "../../../services/httpService";
import { GoArrowLeft } from "react-icons/go";
import "../../../../src/TextFamily.css";
import "../PopUp.css";
import "../DeshBoard.css";
import { url, subscriptionKey } from "../../../constants";
import axios from "axios";
import Loader from "../LoaderModal";
import { getFilePreview } from "../../../utils/utils";

const ProductUploadModal = (props) => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [currentPreview, setCurrentPreview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [byerPlatformSaved, setBuyerPlatformSaved] = useState(false);
  const id = localStorage.getItem("_id");
  const tokenHeader = localStorage.getItem("_token") || "";
  const merchantId = localStorage.getItem("_id");

  const fetchData = async () => {
    try {
      const response = await Api(
        "get",
        `/documents/getDocListByDocInfoId/${props?.selectedProduct?.id}/BUYER_PLATFORM/22`
      );
      if (response && response?.data?.length > 0) {
        const files = [];
        response?.data?.map((item) => {
          files.push({
            docId: item?.docId,
            fileId: item?.fileId,
            fileName: item?.fileName,
            fileType: item?.fileType,
          });
        });
        setUploadedFiles(files);
      } else {
        console.warn("No Uploads found in response.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [props?.selectedProduct]);

  const getFile = async (file) => {
    try {
      setLoading(true);
      const fileRes = await fetch(`${url}/files/${file?.fileId}`, {
        method: "GET",
        headers: {
          "Ocp-Apim-Subscription-Key": subscriptionKey,
          Authorization: tokenHeader,
        },
        redirect: "follow",
      });

      if (fileRes.ok && fileRes.body) {
        const blob = await fileRes.blob();
        const reader = new FileReader();

        reader.onloadend = () => {
          const base64data = reader.result;
          setCurrentPreview({
            url: base64data,
            name: file?.fileName || uploadedFiles[0]?.name || "Document",
          });
          setShowPreview(true);
        };

        reader.readAsDataURL(blob);
      }
    } catch (err) {
      console.error(`Failed to fetch logo for platform ${logoId}:`, err);
    } finally {
      setLoading(false);
    }
  };

  const saveBuyerPlatform = async (buyerId) => {
    buyerId = buyerId.toString();
    try {
      setLoading(true);
      const result = await axios({
        method: "put",
        url:
          url +
          "/merchantBuyerPlatforms" +
          "?bp_id=" +
          buyerId +
          "&m_id=" +
          merchantId,
        headers: {
          "Ocp-Apim-Subscription-Key": subscriptionKey,
          Authorization: tokenHeader,
        },
      });
      if (result?.data && result?.data?.success) {
        setBuyerPlatformSaved(true);
      } else {
        setLoading(false);
        setBuyerPlatformSaved(false);
      }
    } catch (err) {
      console.log(err, "Error fetching");
      setLoading(false);
      setBuyerPlatformSaved(false);
    }
  };

  const handleFileUpload = async (files) => {
    const validTypes = ["application/pdf"];

    const filtered = files.filter(
      (file) => validTypes.includes(file.type) && file.size <= 15 * 1024 * 1024
    );

    if (filtered.length !== files.length) {
      // alert("Some files were rejected. Only PDF under 15MB are allowed.");
      return;
    }
    if (byerPlatformSaved) {
      await uploadFile(filtered[0]);
    } else {
      await saveBuyerPlatform(props?.selectedProduct?.id);
      await uploadFile(filtered[0]);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const files = Array.from(e.dataTransfer.files);
    if (uploadedFiles.length < 1 && files.length > 0) {
      handleFileUpload(files);
    }
  };

  const uploadFile = async (file) => {
    try {
      //api call to upload bank statement
      setLoading(true);
      const formData = new FormData();
      formData.append("documentInfoId", 22);
      formData.append("entityType", "BUYER_PLATFORM");
      formData.append("entityId", props?.selectedProduct?.id);
      formData.append("docPrintedId", "");
      formData.append("docCountry", "UAE");
      formData.append("docIssueDate", "");
      formData.append("docExpiryDate", "");
      formData.append("merchantId", props?.merchantId);
      formData.append("files", file);

      formData.append("fileBack", "");
      formData.append("proofFile", "");

      const response = await Api(
        "post",
        `/documents/uploadOrUpdateDocuments`,
        formData,
        true
      );

      if (response.success && response.body) {
        setLoading(false);
        let file = response?.body[0]?.file;
        setUploadedFiles((prev) => {
          return [
            ...prev,
            {
              docId: response?.body[0]?.docId,
              fileId: file?.id,
              fileName: file?.fileName,
              fileType: file?.fileType,
            },
          ];
        });
      } else {
        setLoading(false);
        console.error("Error during submission:", response);
      }
    } catch (err) {
      setLoading(false);
      console.error("Error during submission:", err);
    }
  };

  const getDaysAgoText = (input) => {
    // Handle both Date objects and date strings
    const uploadedDate = input instanceof Date ? input : new Date(input);
    if (isNaN(uploadedDate)) return "Invalid date";

    // Zero out the time part of both dates
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const uploaded = new Date(uploadedDate);
    uploaded.setHours(0, 0, 0, 0);

    // Calculate the difference in days
    const timeDiff = today - uploaded;
    const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

    if (daysDiff === 0) return "Uploaded today";
    if (daysDiff > 0)
      return `Uploaded ${daysDiff} day${daysDiff > 1 ? "s" : ""} ago`;
    return `Uploaded in ${Math.abs(daysDiff)} day${
      Math.abs(daysDiff) > 1 ? "s" : ""
    }`;
  };

  const handleSubmit = async () => {
    try {
      setLoading(false);
      setUploadedFiles([]);
      props?.setShow(false);
      props?.setProductBrand(false);
      props?.setBuyer(null);
      props?.setSelectedProduct(null);
    } catch (err) {
      setLoading(false);
      console.error("Error during submission:", err);
    }
  };

  const handleRemoveFile = async (file) => {
    try {
      setLoading(true);
      const response = await Api(
        "delete",
        `/documents/deleteDocById/${file?.docId}`
      );
      if (response.success) {
        let id = response?.body?.file?.id;
        const updatedFiles = uploadedFiles.filter((file) => id != file?.fileId);
        setUploadedFiles(updatedFiles);
      }
    } catch (error) {
      console.error("Error found in response:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePreview = async (file) => {
    if (file) {
      try {
        setLoading(true);
        const { success, preview } = await getFilePreview(file);
        if(success){
          setCurrentPreview({
            url: preview?.url,
            name: preview?.name || uploadedFiles[0]?.name || "Document",
          });
          setShowPreview(true);
        }else {
          alert("Unable to load preview.");
        }
      } catch (error) {
        alert("Unable to load preview.");
      }finally{
        setLoading(false);
      }
    } else {
      console.error("Invalid file type for preview:", file);
    }
  };

  /* ---------- Handlers ---------- */
  const handleClose = () => {
    props?.setShow(false);
    props?.setSelectedProduct(null);
    setUploadedFiles([]);
  };

  return (
    <>
      {/* Upload Modal */}
      <Modal
        show={props.show}
        onHide={handleClose}
        backdrop="static"
        className="company-add-popup financing-solution-popup"
        keyboard={false}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="d-flex py-4 px-4">
          <div className="arrow-btn " onClick={handleClose}>
            <GoArrowLeft />
          </div>
          {props?.logoIcon && (
            <div className="p-img-box rounded-circle overflow-hidden d-flex align-items-center justify-content-center mx-3">
              <img
                className="rounded-circle"
                src={props?.logoIcon}
                alt={props?.selectedProduct?.name}
              />
            </div>
          )}
          <div className="modal-title-detail">
            <h3 className="title-brand">{props?.selectedProduct?.name}</h3>
            <p className="brand-name mb-0">{props?.buyer?.typeName}</p>
          </div>
          {/* Buyer Note */}
          {/* <Modal.Title>Last 6 months invoice</Modal.Title> */}
        </Modal.Header>

        <Modal.Body className="p-4">
          <div className="guideline-sec">
            <h2>Guidelines</h2>
            <ul>
              <li className="mb-2">
                Upload the consolidated bank statement for the last 6 months for
                the bank account where invoice payments from this buyer platform
                are received.
              </li>
              <li className="mb-2">
                Supported format: PDF (max 15MB per file).
              </li> 
            </ul>
          </div>

          {uploadedFiles.length > 0 &&
            uploadedFiles.map((file, index) => (
              <div
                key={`${file?.fileName}-${index}`}
                className="file-upload-white-box d-flex align-items-start justify-content-between p-3 mb-3 bg-white mt-4"
              >
                <div className="d-flex align-items-center flex-grow-1">
                  <div className="me-3">
                    <div className="load-img-box rounded-circle p-1 d-flex align-items-center justify-content-center">
                      <img src={Document_show} alt="Document Icon" />
                    </div>
                  </div>
                  <div className="file-upload-box">
                    <div
                      className="file-title text-truncate mb-1"
                      style={{ maxWidth: "200px" }}
                    >
                      {file?.fileName}
                    </div>
                    <div className="file-sub-title">
                      {getDaysAgoText(
                        file.docIssueDate ? file.docIssueDate : Date.now()
                      )}
                    </div>
                    <div
                      className="file-preview mt-2"
                      style={{ cursor: "pointer" }}
                      onClick={() => handlePreview(file)}
                    >
                      Tap to Preview
                    </div>
                  </div>
                </div>
                <button
                  className="btn btn-link text-danger p-0"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemoveFile(file);
                  }}
                  title="Delete"
                  aria-label="Delete file"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-trash3"
                    viewBox="0 0 16 16"
                  >
                    <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                  </svg>
                </button>
              </div>
            ))}
          {loading ? (
            <Loader />
          ) : (
            <>
              {uploadedFiles.length < 1 && (
                <div
                  className="license-upload-section d-flex flex-column align-items-center justify-content-center p-4 mt-4"
                  style={{ borderStyle: "dashed", cursor: "pointer" }}
                  onClick={() => document.getElementById("fileUpload").click()}
                  role="button"
                  tabIndex="0"
                  onKeyDown={(e) =>
                    e.key === "Enter" &&
                    document.getElementById("fileUpload").click()
                  }
                  onDragOver={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  onDrop={handleDrop}
                >
                  <img src={UploadDoc} alt="Upload Icon" />
                  <p className="mb-1">Upload Document</p>
                  <small>(PDF supported)</small>
                  <input
                    id="fileUpload"
                    type="file"
                    accept=".pdf"
                    multiple
                    hidden
                    onChange={(e) =>
                      handleFileUpload(Array.from(e.target.files))
                    }
                    disabled={uploadedFiles.length == 1}
                  />
                </div>
              )}
            </>
          )}
          {/* {uploadedFiles.length >= 1 && (
            <div className="alert alert-warning mt-2">
              You've reached the maximum of 1 file.
            </div>
          )} */}
        </Modal.Body>

        <Modal.Footer className="p-3 border-0">
          <Button
            variant={uploadedFiles.length > 0 ? "primary active" : "primary "}
            disabled={uploadedFiles.length <= 0}
            onClick={handleSubmit}
          >
            Continue
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Preview Modal */}
      {showPreview && (
        <Modal
          show={showPreview}
          onHide={() => {
            setShowPreview(false);
            if (currentPreview) {
              URL.revokeObjectURL(currentPreview);
            }
          }}
          size="lg"
          backdrop="static"
          className="Upload-trade-license"
          keyboard={false}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton className="justify-content-between">
            <Modal.Title className="text-truncate" style={{ maxWidth: 500 }}>
              {currentPreview.name}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            className="text-center"
            style={{ maxHeight: "80vh", overflow: "auto" }}
          >
            <div>
              {currentPreview &&
              currentPreview.name.toLowerCase().includes(".pdf") ? (
                <iframe
                  src={currentPreview.url}
                  title="PDF Preview"
                  width="100%"
                  height="600px"
                  style={{ border: "none" }}
                />
              ) : (
                <img
                  src={currentPreview.url}
                  alt="Preview"
                  style={{ maxWidth: "100%", height: "auto" }}
                />
              )}
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default ProductUploadModal;
